import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

const headers = new HttpHeaders({
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
});

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  branchUrl = '/superadmin/rest/mgmt/corporate/branch';
  constructor(private http: HttpClient) { }

  getBranches( filter, sortOrder,
    pageNumber, pageSize = 10): Observable<any> {
      return this.http.get(this.branchUrl + '?' + filter, {
          params: new HttpParams()
          .set('asc', sortOrder)
              .set('from', pageNumber.toString())
              .set('count', pageSize.toString())
      });
    }
    getTotalbranchCount(filter: any): any {
      return this.http.get(this.branchUrl + '/count?' + filter, { headers: headers });
    }

}
